<span *ngIf="isCanAssignTicket && !isMatrix">
  <app-checkbox>
    <input type="checkbox" id="{{ ticket.ticket_number }}" [(ngModel)]="ticket.isChecked" (ngModelChange)="onCheckedTicket()" />
  </app-checkbox>
</span>

<div
  *ngIf="isCanAssignTicket && isMatrix"
  class="ticket__checker"
  [ngClass]="{
    'bg-gray-pale': !ticket.isChecked,
    'bg-yellow-light': ticket.isChecked
  }"
>
  <app-checkbox>
    <input type="checkbox" id="{{ ticket.ticket_number }}" [(ngModel)]="ticket.isChecked" (ngModelChange)="onCheckedTicket()" />
  </app-checkbox>
</div>
